import React, { useState, useEffect } from "react";
import axios from "axios";
import Alert from "./components/Alert";
import "./App.css";
import s1 from "./s1.png";
import s2 from "./s2.png";
import s3 from "./s3.png";
import s4 from "./s4.png";
import s5 from "./s5.png";
import s6 from "./s6.jpg";
import s7 from "./s7.png";
import s8 from "./s8.png";
import s9 from "./s9.png";
import s10 from "./s10.png";

const App = () => {
  const [activeSection, setActiveSection] = useState("about");
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userMessage, setUserMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [messageSent, setMessageSent] = useState(false)
  const [alert, setAlert] = useState(null)

  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        "about",
        "skills",
        "work",
        "education",
        "experience",
        "contact",
      ];
      let current = "";

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element && element.getBoundingClientRect().top <= 100) {
          current = section;
        }
      }

      setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const skills = [
    {
      icon: "💻",
      title: "Frontend Developer",
      description:
        "I like to code things from scratch, and enjoy bringing ideas to life in the browser.",
      languages: "Languages:",
      languagesList: [
        "HTML",
        "CSS",
        "JavaScript",
        "React",
        "Redux",
        "TypeScript",
      ],
      tools: "Dev Tools:",
      toolsList: [
        "VS Code",
        "Firebase",
        "Git",
        "Material-UI",
        "Figma",
        "React Testing Library",
      ],
    },
    {
      icon: "🛠️",
      title: "Full Stack Developer",
      description:
        "I value simple content structure, clean design patterns, and thoughtful interactions.",
      languages: "Things I enjoy developing:",
      languagesList: ["UX", "UI", "Web Apps", "Mobile Apps", "APIs"],
      tools: "Frameworks I Use:",
      toolsList: [
        "Next.js",
        "Node.js",
        "Express",
        "MongoDB",
        "PostgreSQL",
        "REST APIs",
      ],
    },
    {
      icon: "👥",
      title: "Team Player",
      description:
        "I genuinely care about people, and love helping fellow developers work on their craft.",
      languages: "Experiences I draw from:",
      languagesList: [
        "Technical Leadership",
        "Code Reviews",
        "Mentoring",
        "Agile Development",
      ],
      tools: "Career Stats:",
      toolsList: [
        "3+ years experience",
        "10+ projects delivered",
        "1000+ students impacted",
        "Multiple certifications",
      ],
    },
  ];

  const projects = [
    {
      title: "ProductionCMS",
      description: "A comprehensive project tracking system",
      image: s2,
      link: "https://prodcms.unicornfortunes.com/",
    },
    {
      title: "CU-LMS",
      description: "Advanced Learning Management System",
      image: s6,
      link: "#",
    },
    {
      title: "Intranet Portal",
      description: "Payment & Attendance System",
      image: s8,
      link: "#",
    },
    {
      title: "Bulk Mail Service",
      description: "High-volume email delivery system",
      image: s7,
      link: "#",
    },
    {
      title: "Movie Rating App",
      description: "IMDb-style movie database",
      image: s5,
      link: "https://github.com/saurabh-singh-au13/Movies-Shows-Rating-App",
    },
    {
      title: "Disney+ Clone",
      description: "Streaming platform UI clone",
      image: s4,
      link: "https://disneyplus-clone-1f559.web.app/",
    },
    {
      title: "Netflix GPT",
      description: "Streaming platform and rendering movie list like Netflix",
      image: s9,
      link: "#",
    },
    {
      title: "Swiggy",
      description: "Swiggy made with real Swiggy API.",
      image: s10,
      link: "#",
    },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    try {
      const payload = {
        name: userName,
        email: userEmail,
        message: userMessage,
      }

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        url: "https://portfolio-backend-7-94wy.onrender.com/user",
        data: payload,
      }

      const response = await axios(config)
      if (response?.status === 200) {
        setAlert({ message: "We will be in touch! ", type: "success" })
        setUserName("")
        setUserEmail("")
        setUserMessage("")
        setMessageSent(true)
      } else {
        setAlert({ message: "Something went wrong", type: "error" })
      }
    } catch (err) {
      console.log(err)
      setAlert({ message: "An error occurred while sending the message", type: "error" })
    } finally {
      setIsLoading(false)
    }
  }

  const closeAlert = () => {
    setAlert(null)
  }

  return (
    <div className="app">
       {alert && <Alert message={alert.message} type={alert.type} onClose={closeAlert} />}
      <aside className="sidebar">
        <h1 className="name">SKS</h1>
        <h2 className="title">Frontend Developer & React.js Expert</h2>
        <p className="description">
          I design and code beautifully simple things, and I love what I do.
        </p>
        <nav>
          <ul>
            <li className={activeSection === "about" ? "active" : ""}>
              <a href="#about">About</a>
            </li>
            <li className={activeSection === "skills" ? "active" : ""}>
              <a href="#skills">Skills</a>
            </li>
            <li className={activeSection === "work" ? "active" : ""}>
              <a href="#work">Work</a>
            </li>
            <li className={activeSection === "education" ? "active" : ""}>
              <a href="#education">Education</a>
            </li>
            <li className={activeSection === "experience" ? "active" : ""}>
              <a href="#experience">Experience</a>
            </li>
            <li className={activeSection === "contact" ? "active" : ""}>
              <a href="#contact">Contact</a>
            </li>
          </ul>
        </nav>
        <div className="social-links">
          <a
            href="https://github.com/saurabh-singh-au13"
            target="_blank"
            rel="noopener noreferrer"
          >
            GitHub
          </a>
          <a
            href="https://linkedin.com/in/saurabh-kumar-singh-904a11190"
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn
          </a>
        </div>
      </aside>
      <main className="content">
        <section id="about">
          <h2>About Me</h2>
          <p>
            I'm a frontend developer passionate about crafting accessible,
            pixel-perfect user interfaces that blend thoughtful design with
            robust engineering. My favorite work lies at the intersection of
            design and development, creating experiences that not only look
            great but are meticulously built for performance and usability.
          </p>
        </section>

        <section id="skills">
          <h2>My Skills</h2>
          <div className="skills-grid">
            {skills.map((skill, index) => (
              <div key={index} className="skill-card">
                <div className="skill-icon">{skill.icon}</div>
                <h3>{skill.title}</h3>
                <p>{skill.description}</p>
                <h4>{skill.languages}</h4>
                <ul>
                  {skill.languagesList.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
                <h4>{skill.tools}</h4>
                <ul>
                  {skill.toolsList.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        <section id="work">
          <h2>My Recent Work</h2>
          <p className="section-description">
            Here are a few past design projects I've worked on. Want to see
            more? <a href="mailto:saurabh0101906@gmail.com">Email me</a>.
          </p>
          <div className="project-grid">
            {projects.map((project, index) => (
              <a
                key={index}
                href={project.link}
                className="project-card"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={project.image} alt={project.title} />
                <div className="project-info">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                </div>
              </a>
            ))}
          </div>
        </section>

        <section id="education">
          <h2>Education</h2>
          <div className="education-grid">
            <div className="education-card">
              <h3>Information Technology</h3>
              <h4>RKGIT, AKTU</h4>
              <p className="duration">08/2016 - 08/2020</p>
              <p className="location">Ghaziabad UP</p>
            </div>

            <div className="education-card">
              <h3>Full Stack Developer Internship</h3>
              <h4>AttainU</h4>
              <p className="duration">2021 - 2021 Year</p>
              <p>Completed intensive training in full-stack development</p>
            </div>

            <div className="education-card">
              <h3>Frontend Development Certification</h3>
              <h4>NamasteDev.com</h4>
              <p>120 hours of Frontend Development mastery course</p>
            </div>
          </div>
        </section>

        <section id="experience">
          <h2>Work Experience</h2>
          <div className="timeline">
            <div className="experience-card">
              <div className="experience-header">
                <h3>Frontend Developer</h3>
                <span className="company">Chandigarh University</span>
                <span className="duration">05/2023 - Present</span>
                <span className="location">Punjab Mohali</span>
              </div>
              <ul className="achievements">
                <li>
                  Developed a comprehensive production tracker and studio
                  booking application
                </li>
                <li>
                  Created a robust bulk email service handling 40,000 emails
                </li>
                <li>Developed slot booking application for online learners</li>
                <li>Built CU-digi Class Learning Management System</li>
                <li>Collaborated with VC for software requirements</li>
              </ul>
            </div>

            <div className="experience-card">
              <div className="experience-header">
                <h3>Software Developer</h3>
                <span className="company">Classic Informatics</span>
                <span className="duration">12/2021 - 04/2023</span>
                <span className="location">Gurugram HR</span>
              </div>
              <ul className="achievements">
                <li>
                  Developed Timesheet Automation and Lead Generation systems
                </li>
                <li>Created responsive Lead Generation Dashboard with Redux</li>
                <li>Worked on Re-scaler project creating modular components</li>
              </ul>
            </div>
          </div>
        </section>

        <section id="contact">
          <h2>Get in Touch</h2>
          <p className="contact-intro">
            I'm always interested in hearing about new projects and
            opportunities.
          </p>

          <div className="contact-grid">
            <div className="contact-info">
              <div className="contact-item">
                <i className="icon-email"></i>
                <a href="mailto:saurabh0101906@gmail.com">
                  saurabh0101906@gmail.com
                </a>
              </div>
              <div className="contact-item">
                <i className="icon-phone"></i>
                <a href="tel:+917291089688">+91 7291089688</a>
              </div>
              <div className="contact-item">
                <i className="icon-linkedin"></i>
                <a
                  href="https://linkedin.com/in/saurabh-kumar-singh-904a11190"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn Profile
                </a>
              </div>
            </div>

            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  onChange={(e) => setUserName(e.target.value)}
                  value={userName}
                  type="text"
                  id="userName"
                  name="userName"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="userEmail"
                  name="userEmail"
                  onChange={(e) => setUserEmail(e.target.value)}
                  value={userEmail}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="userMessage"
                  name="userMessage"
                  rows="5"
                  onChange={(e) => setUserMessage(e.target.value)}
                  value={userMessage}
                  required
                ></textarea>
              </div>
              <button type="submit" className={`submit-button ${isLoading ? "loading" : ""}`} disabled={isLoading}>
            {isLoading ? <span className="loader"></span> : "Send Message"}
          </button>
              {messageSent && <p>Message sent successfully!</p>}
            </form>
          </div>
        </section>
      </main>
    </div>
  );
};

export default App;
